import { importExcelFile } from "services/lickycService";
import {
  setLickycLoader,
  importExcelSuccessMsg,
  importExcelErrorMsg,
} from "./reducer";

export const importExcelFileThunk =
  (fileUrl: string) => async (dispatch: (action: any) => void) => {
    dispatch(setLickycLoader(true));
    try {
      const response = await importExcelFile({ file_url: fileUrl });
      if (response.success) {
        dispatch(
          importExcelSuccessMsg({
            message: response.message || "Excel imported successfully",
            id: Date.now().toString(),
          })
        );
        return response;
      } else {
        dispatch(
          importExcelErrorMsg({
            message: response.message || "Failed to import excel",
            id: Date.now().toString(),
          })
        );
        return response;
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";
      dispatch(
        importExcelErrorMsg({
          message: errorMessage,
          id: Date.now().toString(),
        })
      );
      return null;
    } finally {
      dispatch(setLickycLoader(false));
    }
  };
